module.exports = __webpack_public_path__ + "img/54.829c0fa0.jpg";